
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 11c0 1.648.665 3.142 1.74 4.226.104.104.156.157.187.207.03.048.046.09.06.144.013.057.013.123.013.253v2.37c0 .28 0 .42.054.527a.5.5 0 00.219.218C6.38 19 6.52 19 6.8 19h1.9c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42.054-.527a.5.5 0 01.219-.218C9.88 17 10.02 17 10.3 17h1.4c.28 0 .42 0 .527.055a.5.5 0 01.218.218c.055.107.055.247.055.527v.4c0 .28 0 .42.054.527a.5.5 0 00.219.218c.107.055.247.055.527.055h1.9c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C16 18.62 16 18.48 16 18.2v-.976c0-.202 0-.303.029-.384a.462.462 0 01.121-.19c.061-.06.166-.108.374-.205a6.025 6.025 0 002.427-2.055c.107-.155.16-.233.217-.28a.464.464 0 01.17-.089c.07-.021.154-.021.32-.021h.542c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C21 13.62 21 13.48 21 13.2V9.786c0-.267 0-.4-.05-.503a.5.5 0 00-.233-.233C20.614 9 20.481 9 20.214 9c-.193 0-.29 0-.367-.026a.463.463 0 01-.203-.13c-.057-.06-.103-.16-.195-.359a6.014 6.014 0 00-1.19-1.711c-.104-.105-.155-.157-.186-.207a.462.462 0 01-.06-.144C18 6.366 18 6.3 18 6.17V5.06c0-.36 0-.54-.075-.66a.5.5 0 00-.288-.218c-.137-.039-.31.01-.657.11l-2.372.677a.498.498 0 01-.136.029C14.45 5 14.43 5 14.388 5h-.429m-9.96 6a6 6 0 013.205-5.31M4 11H3a2 2 0 01-1-3.732M14 4.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z","stroke":"#232859","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    